<div class="flex flex-row justify-between items-center py-2 px-2">
  <h3 class="font-bold text-2xl text-teal-900">Filtros</h3>
  <p-button icon="pi pi-refresh" pTooltip="Reestablecer filtros" tooltipPosition="left" styleClass="p-button-secondary p-button-rounded" (onClick)="resetFilters()"></p-button>
</div>

<div *ngFor="let filter of filters; let i = index;" class="grid grid-cols-1 px-2">
  <h4 class="font-bold col-span-4 pb-1">{{filter.name}}</h4>
  <ng-container *ngIf="filter.type === 'single'">
    <div class="flex align-middle flex-row justify-start mb-4">
      <ng-container *ngFor="let option of filter.options; let ind = index">
        <p-radioButton [(ngModel)]="selection[i]" labelStyleClass="mr-2 text-sm" [name]="filter.column + '_' + ind" [value]="option" [label]="option" (onChange)="processChange()"></p-radioButton>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="filter.type === 'multiple'">
    <p-multiSelect
      [options]="filter.options"
      [(ngModel)]="selection[i]"
      [filter]="true"
      (onChange)="processChange()"
      styleClass="w-full h-12 mb-3"
      panelStyleClass="w-full"></p-multiSelect>
  </ng-container>
  <ng-container *ngIf="filter.type === 'range'">
    <div class="grid grid-cols-9 gap-6 mb-3">
      <div class="flex flex-col justify-start align-middle h-full p-0 m-0 col-span-2">
        <label class="text-xs font-bold h-full bg-white border border-gray-500 rounded shadow p-2 text-center  text-teal-700">{{selection[i][0]}}€</label>
      </div>
      <div class="col-span-5">
        <p-slider styleClass="flex flex-col mt-4 align-middle h-full p-0 m-0 w-full"
          [min]="filter.options[0]"
          [max]="filter.options[1]"
          [step]="1"
          [(ngModel)]="selection[i]"
          (onSlideEnd)="processChange()"

          [range]="true"></p-slider>
      </div>
      <div class="flex flex-col justify-start align-middle h-full p-0 m-0 col-span-2">
        <label class="text-xs font-bold h-full bg-white border border-gray-500 rounded shadow p-2 text-center text-teal-700">{{selection[i][1]}}€</label>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="filter.type === 'daterange'">
    <p-calendar
      [(ngModel)]="selection[i]"
      selectionMode="range"
      [minDate]="filter.options[0]"
      [maxDate]="filter.options[1]"
      styleClass="w-full h-12 mb-3"
      (onClose)="processChange()"
      [readonlyInput]="true"
      [showIcon]="true"
      dateFormat="d/m/yy"
      [showButtonBar]="true"
      [readonlyInput]="true"></p-calendar>
  </ng-container>
</div>

